import React from "react";
import { FormattedMessage } from "react-intl"

/* AUTHORIZATION_IMAGES_VALUES select values */
export const AUTHORIZATION_IMAGES_VALUES = [
  {
    id: 1,
    label: (
      <FormattedMessage 
        id="ProjectStepForm.step3.field.requiredCredits.authorizationImages"
        defaultMessage="Uso libre, pero requiere créditos"
      />
    ),
    value: "FOR_INTERNAL_USE_ONLY",
    comparedValue: "FOR INTERNAL USE ONLY"
  },
  {
    id: 2,
    label: (
      <FormattedMessage 
        id="ProjectStepForm.step3.field.notRequiredCredits.authorizationImages"
        defaultMessage="Uso libre, sin necesidad de créditos"
      />
    ),
    value: "TOTAL_AUTHORIZATION",
    comparedValue: "TOTAL AUTHORIZATION",
    color: "text-success"
  },
  {
    id: 3,
    label: (
      <FormattedMessage 
        id="ProjectStepForm.step3.field.restringedUse.authorizationSupport"
        defaultMessage="Uso restringido. Se requiere autorización"
      />
    ),
    value: "NO_AUTHORIZATION",
    comparedValue: "NO AUTHORIZATION",
    color: "text-danger"
  },
]

/* Area select Values */
export const AUTHORIZATION_PROJECT_VALUES = [
  {
    id: 1,
    label: (
      <FormattedMessage 
        id="ProjectStepForm.step3.field.yes.authorizationProject"
        defaultMessage="Si"
      />
    ),
    value: "Yes",
  },
  {
    id: 2,
    label: (
      <FormattedMessage 
        id="ProjectStepForm.step3.field.no.authorizationProject"
        defaultMessage="No"
      />
    ),
    value: "No",
  }
]